import React, { CSSProperties } from 'react';

interface IIconProps {
  type: string
  size?: number
  title?: string
}

export const SystemIcon = ({ type, size, title }: IIconProps) => {
  const style: CSSProperties = {};

  if (size) {
    style.fontSize = `${size}px`;
  }
  
  return (
    <i className={`icon-${type}`} style={style} title={title || ''}></i>
  );
}